import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAyD4-3m3nVEW9Fbql4ho0CRmRqpDKeoYo",
  authDomain: "prod-imlca.firebaseapp.com",
  databaseURL: "https://prod-imlca.firebaseio.com",
  projectId: "prod-imlca",
  storageBucket: "prod-imlca.appspot.com",
  messagingSenderId: "1018423316611"
};

export const states = ["AK", "AL", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY", "AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"];

export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore()